import { Tag } from "antd";
import type { FC } from "react";
import type { User } from "../../types";

type Plan = User["plan"];

const CONFIG: Record<Plan, { label: string; color?: string }> = {
  free: { label: "Free" },
  pro: { label: "Pro", color: "blue" },
  agency: { label: "Agency", color: "gold" },
};

export const PlanTag: FC<{ plan: Plan }> = ({ plan }) => {
  const { label, color } = CONFIG[plan] ?? CONFIG.free;
  return <Tag color={color}>{label}</Tag>;
};

